import React from "react"
import PropTypes from "prop-types"

import Typograph from "../../../../components/Typograph"

import styles from "./styles.css"

import iconInfo from "../../../../assets/svg/fixed-voice-info.svg"

const OrderInfo = ({ text }) => {
  return (
    <div className={styles.separate}>
      <div className={styles.info}>
        <div className={styles.icon}>
          <img src={iconInfo} alt={"iconInfo"} />
        </div>
        <div>
          <Typograph
            htmlTag="span"
            size="extra_small"
            weight="semi_bold"
            color="blue_cola"
          >
            {text}
          </Typograph>
        </div>
      </div>
    </div>
  )
}

OrderInfo.propTypes = {
  text: PropTypes.string
}
export default OrderInfo



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/ConfirmScreen/OrderInfo.js